import { FiatOptionModel, PayMethodModel } from '@kano/models';
import MethodClient from '@/network/pay-methods';
import type { Currency } from '@/types';
import UserService from '@/services/UserService';
import { listModelFactory } from '@kano/models';

export default {
    async listFiatPaymentMethods(from: Currency, to: Currency) {
        const userType= await UserService.getUserType();
        return MethodClient.paymentMethods(from, to, userType)
            .then(({ data }) => data)
            .then(items => items.map(item => new PayMethodModel(item, from)))
            .then(listModelFactory(FiatOptionModel));
    },
    async listFiatPayoutMethods(from: Currency, to: Currency) {
        const userType= await UserService.getUserType();
        return MethodClient.payoutMethods(from, to, userType)
            .then(({ data }) => data)
            .then(items => items.map(item => new PayMethodModel(item, to)))
            .then(listModelFactory(FiatOptionModel));
    },
};
